require('./commands/alertnate_appointment_times_confirmation_command.ts');
require('./commands/appointment_scheduling_type_selected_command.ts');
require('./commands/appointments_confirm_command.ts');
require('./commands/appointments_confirmation_comand.ts');
require('./commands/appointments_course_selected_command.ts');
require('./commands/appointments_location_selected_command.ts');
require('./commands/appointments_service_category_selected_command.ts');
require('./commands/appointments_service_selected_command.ts');
require('./commands/appointments_staff_selected_command.ts');
require('./commands/appointments_time_selection_change_command.ts');
require('./commands/cancel_appointment.ts');
require('./commands/clear_all_appointments_datasources.ts');
require('./commands/clear_appointments_cache_on_server_command.ts');
require('./commands/load_appointment_type_configuration_service_command.ts');
require('./commands/load_appointments_available_times_command.ts');
require('./commands/load_appointments_locations_command.ts');
require('./commands/load_available_walkin_times_command.ts');
require('./commands/load_cancellation_reasons.ts');
require('./commands/load_upcoming_appointments.ts');
require('./commands/prepare_appointment_campaign_request.ts');
require('./commands/appointments_checkin_command.ts');
require('./commands/appointments_checkout_command.ts');
require('./commands/appointments_dropin_command.ts');
require('./components/appointment_cancel_form/appointment_cancel_form.ts');
require('./components/appointment_card/appointment_card.ts');
require('./components/appointment_details/appointment_details.ts');
require('./components/appointment_footer_button/appointment_footer_button.ts');
require('./components/appointment_request/appointment_request.ts');
require('./components/appointments_link/appointments_link.ts');
require('./components/appointment_checkin/appointment_checkin.ts');
require('./components/appointment_dropin/appointment_dropin.ts');
require('./components/choice_selector/choice_selector.ts');
require('./components/components_module.ts');
require('./components/dead_end/dead_end.ts');
require('./components/my_appointments/my_appointments.ts');
require('./components/scroll_content/scroll_content.ts');
require('./config/appointment_scheduling_configuration.ts');
require('./config/config_module.ts');
require('./datasources/appointment_location_staff_datasource.ts');
require('./datasources/appointment_reason_type_datasource.ts');
require('./datasources/appointments_available_times_datasource.ts');
require('./datasources/appointments_available_times_datasource1.ts');
require('./datasources/appointments_locations_datasource.ts');
require('./datasources/cancellation_reasons_datasource.ts');
require('./datasources/datasources_module.ts');
require('./datasources/upcoming_appointments_datasource.ts');
require('./enums/appointments_tab_enum.ts');
require('./enums/enums_module.ts');
require('./enums/reminder_enum.ts');
require('./models/confirm_appointment_model.ts');
require('./queries/appointments_available_times_query.ts');
require('./queries/appointments_confirm_query.ts');
require('./queries/appointments_courses_query.ts');
require('./queries/appointments_locations_query.ts');
require('./queries/appointments_organizers_query.ts');
require('./queries/appointments_reason_query.ts');
require('./queries/appointments_service_categories_query.ts');
require('./queries/appointments_service_query.ts');
require('./queries/cancellation_reasons_query.ts');
require('./queries/queries_module.ts');
require('./queries/upcoming_appointments_query.ts');
require('./routes.ts');
require('./servants/appointment_button_servant.ts');
require('./servants/appointment_info_servant.ts');
require('./servants/appointment_reminders_servant.ts');
require('./servants/appointments_available_times_servant.ts');
require('./servants/appointments_choice_selector_servant.ts');
require('./servants/appointments_command_servant.ts');
require('./servants/appointments_confirm_servant.ts');
require('./servants/appointments_tabs_configuration.ts');
require('./servants/appointments_usersource_servant.ts');
require('./servants/current_user_appointments_servant.ts');
require('./servants/local_storage_servant.ts');
require('./servants/prepare_appointment_campaign_request_servant.ts');
require('./servants/servants_module.ts');
require('./services/my_appointment_state_service.ts');
require('./services/my_appointments_service.ts');
require('./services/services_module.ts');
require('./types/appointment_interfaces.ts');
require('./types/appt_interfaces.ts');
require('./usersources/alternate_appointment_times_usersource.ts');
require('./usersources/appointment_available_times_usersource.ts');
require('./usersources/appointment_location_staff_usersource.ts');
require('./usersources/appointment_reason_usersource.ts');
require('./usersources/usersources_module.ts');
require('./views/alternate_appointment_times/alternate_appointment_times.ts');
require('./views/alternate_appointment_times_confirm/alternate_appointment_times_confirm.ts');
require('./views/appointment_reason/appointment_reason.ts');
require('./views/appointments/appointments.ts');
require('./views/available_times/available_times.ts');
require('./views/confirm/confirm.ts');
require('./views/location_staff/appointments_location_staff.ts');
require('./views/my_appointments/my_appointments_children_controller.ts');
require('./views/scheduled/scheduled.ts');
require('./views/views_module.ts');
require('./views/walkin_times/walkin_times.ts');
require('./views/walkin_times/walkin_times_controller.ts');



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/core.ts